module.exports = __webpack_public_path__ + "static/media/Drake_Well_Museum_Titusville_PA_Faux_painted_rusted_steel_onwooden_box_finished_2_2011.7340fef9.webp";